// import debounce from './debounce';
// import {changeSpace, changeSpaceDebounced} from '../snippets/header-space';
import {
  isMobile,
  isLargerThanMobile,
  isLargerThanTabletLarge,
  isDesktopSmall,
  isLargerThanTablet,
} from "//auriccosmetics.com/cdn/shop/t/63/assets/media.js?v=21566901417323640031790346580";
import {isModalOpened} from "//auriccosmetics.com/cdn/shop/t/63/assets/modal.js?v=46016976510610131991790350067";
import {EscapeObserver} from "//auriccosmetics.com/cdn/shop/t/63/assets/escapeObserver.js?v=40787582539029033611790346580";
import {getPromoBarHeight} from "//auriccosmetics.com/cdn/shop/t/63/assets/dom.js?v=175014698423836044041790346580";
import debounce from "//auriccosmetics.com/cdn/shop/t/63/assets/debounce.js?v=9266546181275830381790346580";

// if this method is not run it will overlap the header
// export function addHeaderSpace() {
//   changeSpace();

//   window.addEventListener('load', () => {
//     changeSpace();
//   });

//   window.addEventListener('resize', () => {
//     changeSpaceDebounced();
//   });
// }

const HEADER_CLASSNAME = 'header';
const HEADER_LIST_CLASSNAME = 'header__list';
const HEADER_MORE_BUTTON_WRAPPER_CLASSNAME = 'header__more-button-wrapper';
const HEADER_MORE_BUTTON_CLASSNAME = 'header__more-button';
const HEADER_MORE_BUTTON_SHOW_CLASSNAME = 'header__more-button--show';
const HEADER_SEARCH_FORM_CLASSNAME = 'header__search-form';
const HEADER_SEARCH_INPUT_LINK_CLASSNAME = 'header__search-link';
const HEADER_SEARCH_INPUT_CLASSNAME = 'header__search-form-input';
const HEADER_OPTIONS_BUTTON_SEARCH_CLASSNAME = 'header__options-item--search';
const HEADER_OPTIONS_BUTTON_CLOSE_CLASSNAME = 'header__options-item--close';
const HEADER_SEARCH_CONTAINER_CLASSNAME = 'header__search-container';
const HEADER_SEARCH_BACKGROUND_CLASSNAME = 'header__container-search-background';

// SOHO TEMPLATE
const SOHO_HEADER_LOGO = 'header-soho__logo-link';
const SOHO_HEADER_SMALL_LOGO = 'header-soho__small-logo-link';
const SOHO_HEADER_SMALL_LOGO_SHOW = 'header-soho__small-logo-link--show';
const SOHO_HEADER_LINKLIST = 'header-soho__linklist';
const SOHO_HEADER_LINKLIST_BACKGROUND = 'header-soho__linklist-background';
const SOHO_HEADER_LIST_EXTENSION_WRAPPER = 'header-soho__list-extension-wrapper';
const SOHO_HEADER_LINKLIST_EXTENSION = 'header-soho__linklist-extension';

const COLLAPSE_SCROLL_VALUE = 100;
const DEBOUNCE_VALUE = 200;

const header = document.querySelector(`.${HEADER_CLASSNAME}`);
const headerList = document.querySelector(`.${HEADER_LIST_CLASSNAME}`);
const headerMoreButtonWrapper = document.querySelector(`.${HEADER_MORE_BUTTON_WRAPPER_CLASSNAME}`);
const headerMoreButton = document.querySelector(`.${HEADER_MORE_BUTTON_CLASSNAME}`);
const headerOptionsSearchButton = document.querySelector(`.${HEADER_OPTIONS_BUTTON_SEARCH_CLASSNAME}`);
const headerOptionsSearchClose = document.querySelector(`.${HEADER_OPTIONS_BUTTON_CLOSE_CLASSNAME}`);
const headerSearchContainer = document.querySelector(`.${HEADER_SEARCH_CONTAINER_CLASSNAME}`);
const headerSearchForm = document.querySelector(`.${HEADER_SEARCH_FORM_CLASSNAME}`);
const headerSearchInputLink = document.querySelector(`.${HEADER_SEARCH_INPUT_LINK_CLASSNAME}`);
const headerSearchInput = document.querySelector(`.${HEADER_SEARCH_INPUT_CLASSNAME}`);
const headerSearchBackground = document.querySelector(`.${HEADER_SEARCH_BACKGROUND_CLASSNAME}`);
const menuButton = document.querySelector(".header__menu-button");
const cartClose = document.querySelector(".header-cart__close");
const headerOptions = document.querySelector(".header__options");
// SOHO TEMPLATE
const headerSohoLogo = document.querySelector(`.${SOHO_HEADER_LOGO}`);
const headerSohoSmallLogo = document.querySelector(`.${SOHO_HEADER_SMALL_LOGO}`);
const headerSohoList = document.querySelector(`.${SOHO_HEADER_LINKLIST}`);
const headerSohoListBackground = document.querySelector(`.${SOHO_HEADER_LINKLIST_BACKGROUND}`);
const headerSohoListExtension = document.querySelector(`.${SOHO_HEADER_LINKLIST_EXTENSION}`);
const headerSohoListExtensionWrapper = document.querySelector(`.${SOHO_HEADER_LIST_EXTENSION_WRAPPER}`);

const topThreshold = getPromoBarHeight();
let focusTimeout;

const setTranslation = (element, x, y) => {
  const yValue = y !== 0 ? `${y}px` : y;
  element.style.transform = `translate(${x}, ${yValue})`;
};

const handleScroll = (translationSettings) => {
  const {
    elements = [],
    positiveDirection = false,
    stop = true,
    speedFactor = 1,
    initYTranslation,
    xTranslation = 0,
  } = translationSettings;

  if (elements) {
    elements.map((el) => {
      const {scrollY} = window;
      const positive = positiveDirection ? 1 : -1;
      let yTranslation = 0;

      let calculatedTrans = initYTranslation + positive * (scrollY * speedFactor);

      if (stop && Math.max(el.getBoundingClientRect().top, topThreshold) >= topThreshold) {
        yTranslation = Math.max(0, calculatedTrans);
      } else if (!stop) {
        yTranslation = calculatedTrans;
      }

      setTranslation(el, xTranslation, yTranslation);
    });
  }
};

const performLayout = () => {
  if (isModalOpened()) {
    return;
  }

  const {scrollY} = window;

  // we're reusing the soho template until we can separate them
    if (isLargerThanTabletLarge()) {
      if (headerSohoList) {

        var shouldCollapse = scrollY >= COLLAPSE_SCROLL_VALUE * 1.2;

        handleScroll({
          elements: [headerSohoList, headerSohoListBackground],
          initYTranslation: topThreshold + 55,
          xTranslation: shouldCollapse ? '-36%' : '-50%',
        });

        handleScroll({
          elements: [headerSohoLogo],
          positiveDirection: false,
          stop: false,
          speedFactor: 1.5,
          initYTranslation: topThreshold,
          xTranslation: '-50%',
        });

        handleScroll({
          elements: [menuButton, cartClose, headerOptions],
          initYTranslation: topThreshold,
        });

        if (shouldCollapse) {
          headerSohoSmallLogo.classList.add(SOHO_HEADER_SMALL_LOGO_SHOW);
          headerSohoSmallLogo.removeAttribute('tabindex');

          if (headerMoreButton) {
            headerMoreButton.classList.add(HEADER_MORE_BUTTON_SHOW_CLASSNAME);
          }
        } else {
          headerSohoSmallLogo.classList.remove(SOHO_HEADER_SMALL_LOGO_SHOW);
          headerSohoSmallLogo.setAttribute('tabindex', -1);

          if (headerSohoListExtension) {
            headerSohoListExtension.classList.remove('open');
            headerSohoListExtensionWrapper.classList.remove('open');
          }

          if (headerMoreButton) {
            headerMoreButton.classList.remove(HEADER_MORE_BUTTON_SHOW_CLASSNAME);
            headerMoreButton.classList.remove('open');
          }
        }
      }
    } else {
      handleScroll({
        elements: [headerSohoLogo],
        initYTranslation: topThreshold,
        xTranslation: '-50%',
      });

      handleScroll({
        elements: [menuButton, headerOptions],
        initYTranslation: topThreshold,
      });
      setTranslation(cartClose, '0', 0);
    }
};

const getHeaderListOffset = () => {
    return headerSohoList.offsetWidth / 2;
};

const setMoreButtonPosition = () => {
  if (headerMoreButtonWrapper) {
    headerMoreButtonWrapper.style.transform = `translateX(${getHeaderListOffset()}px)`;
    headerMoreButtonWrapper.style.visibility = 'visible';
  }
};

const showExpandedList = () => {
  if (isLargerThanTablet()) {
    headerMoreButton.classList.toggle('open');

      headerSohoListExtensionWrapper.classList.toggle('open');
      headerSohoListExtension.classList.toggle('open');
  }
};

const getInputValue = () => headerSearchInput.value;

const searchBySubmit = (e, input) => {
  e.preventDefault();
  if (input) {
    window.top.location.href = `${getSearchUrl()}?type=search&q=${input}&search=${input}`;
  }
};

const getSearchUrl = () => `${window.location.origin}${headerSearchForm.dataset.url}`;

const searchByButton = (input) => {
  input
    ? headerSearchInputLink.href = `${getSearchUrl()}?type=search&q=${input}&search=${input}`
    : headerSearchInput.focus();
};

const handleSearchOption = () => {
  clearTimeout(focusTimeout);
  headerSearchContainer.classList.toggle('show');
  headerSearchBackground.classList.toggle('show');
  headerOptionsSearchButton.classList.toggle('show');
  headerOptionsSearchClose.classList.toggle('show');
  if (headerSearchContainer.classList.contains('show')) {
    focusTimeout = setTimeout(() => {
      headerSearchInput.focus();
    }, 500);
  }
};

const closeSearch = () => {
  if (
    headerSearchContainer && headerOptionsSearchButton && headerSearchBackground && headerOptionsSearchClose
  ) {
    headerSearchContainer.classList.remove('show');
    headerSearchBackground.classList.remove('show');
    headerOptionsSearchButton.classList.remove('show');
    headerOptionsSearchClose.classList.remove('show');
  }
};

EscapeObserver.onEscape(closeSearch);

if (header) {
  window.addEventListener('scroll', performLayout);
  window.addEventListener('resize', debounce(performLayout, DEBOUNCE_VALUE));
  window.addEventListener('load', debounce(performLayout, DEBOUNCE_VALUE));
  performLayout();
}

if (headerList || headerSohoList) {
  window.addEventListener('resize', debounce(setMoreButtonPosition, DEBOUNCE_VALUE));
  window.addEventListener('load', setMoreButtonPosition);
}

if (headerMoreButton) {
  headerMoreButton.addEventListener('click', showExpandedList);
}

if (headerSearchForm) {
  headerSearchForm.addEventListener('submit', (e) => { searchBySubmit(e, getInputValue()); });
}

if (headerSearchInputLink) {
  headerSearchInputLink.addEventListener('click', () => { searchByButton(getInputValue()); });
}

if (headerOptionsSearchButton) {
  headerOptionsSearchButton.addEventListener('click', handleSearchOption);
}

if (headerOptionsSearchClose) {
  headerOptionsSearchClose.addEventListener('click', handleSearchOption);
}
